var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-md-1"}),_c('div',{staticClass:"mainPages col-md-10"},[_c('MyTablesList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }